import LandingNav from "@/components/layout/LandingNav";
import HeroSection from "@/components/landing/HeroSection";
import {
  WhyBuilders, HowItWorks, HowDifferent, RealExample,
  BuilderPreview, SurveyorPreview, OutsourcedFlow,
  GeneratedPacks, BuiltForBuilders, RoleSelector,
  ExternalPeopleSection, ProjectStartSection,
} from "@/components/landing/LandingSections";
import Footer from "@/components/layout/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <LandingNav />
      <HeroSection />
      <WhyBuilders />
      <HowItWorks />
      <HowDifferent />
      <RealExample />
      <ProjectStartSection />
      <BuilderPreview />
      <SurveyorPreview />
      <ExternalPeopleSection />
      <OutsourcedFlow />
      <GeneratedPacks />
      <BuiltForBuilders />
      <RoleSelector />
      <Footer />
    </div>
  );
}
